export const ENROLMENT_TERMS_VERSION = "2026-04-27";

export type EnrolmentTerm = {
  id: number;
  title: string;
  body: string;
};

export const ENROLMENT_TERMS: EnrolmentTerm[] = [
  {
    id: 1,
    title: "Course Fees",
    body: "All tuition fees must be paid prior to the commencement of the course. All costs are clearly stated with no hidden fees.",
  },
  {
    id: 2,
    title: "Refunds Policy",
    body: "Students are eligible for a full refund if they cancel their registration at least 14 days before the course starts. No refunds will be issued once the course has commenced.",
  },
  {
    id: 3,
    title: "Course Transfers",
    body: "Students may transfer to a different course or exam session provided they submit a written request at least 14 days before the original course starts.",
  },
  {
    id: 4,
    title: "Visa Applications",
    body: "NileWise does not provide visa assistance. It is the full responsibility of the student to ensure they comply with all visa requirements.",
  },
  {
    id: 5,
    title: "Privacy Policy",
    body: "We comply with applicable Data Protection Laws. Student data is collected solely for educational and administrative purposes and will not be shared with third parties without consent, except where required by ACCA.",
  },
  {
    id: 6,
    title: "Declaration",
    body: "By checking this box, I confirm that I have read, understood, and agree to all the terms and conditions outlined above.",
  },
];
